import * as EmailValidator from "email-validator";
import "../../../resources/less/Admin/LoggedOut/loginForCheckout.less";

class CheckoutConfirmation {
  private readonly invalidText: JQuery<HTMLElement>;
  private readonly differentText: JQuery<HTMLElement>;
  private readonly loading: JQuery<HTMLElement>;
  private submitButton: JQuery<HTMLButtonElement>;
  private form: JQuery<HTMLFormElement>;

  constructor() {
    this._firstMail = $("#purchase_email_form_email");
    this.invalidText = $(".field-error-msg");
    this.differentText = $(".different-email-text");
    this.loading = $(".loading");
    this.submitButton = $(".payment-button");
    this.form = $("form[name=purchase_email_form]");

    this._firstMail.on("keyup keypress blur change", () => {
      this.checkUsername();
    });

    this.submitButton.on("click", () => {
      if (!this.submitButton.hasClass("disabled")) {
        this.form.trigger("submit");
      }
    });

    //Validates if emails are prefilled
    this.checkUsername();
  }

  private _firstMail: JQuery<HTMLElement>;

  private get firstMail(): string {
    return this._firstMail.val().toString().trim();
  }

  /**
   * @constructor
   */
  private checkUsername(): void {
    this.submitButton.addClass("disabled");
    if (this.firstMail.length === 0) {
      this.displayStatus();
      return;
    }
    if (!EmailValidator.validate(this.firstMail)) {
      this.displayStatus(this.invalidText);
      return;
    }
    this.displayStatus();
    this.submitButton.removeClass("disabled");
  }

  private displayStatus(messageDiv: JQuery<HTMLElement> = null): void {
    this.differentText.addClass("hide");
    this.loading.addClass("hide");
    this.invalidText.addClass("hide");
    if (messageDiv !== null) {
      messageDiv.removeClass("hide");
    }
  }
}

$(window).on("load", () => {
  new CheckoutConfirmation();
});
